// extracted by mini-css-extract-plugin
module.exports = {"contactWrapperInfo":"style_contactWrapperInfo__WzwXw","infoUnderline":"style_infoUnderline__YsZJz"};